export default __webpack_public_path__ + "static/media/aspen_logo_animated.1587ff2b.svg";